import TimelineContainer from "../../../Components/BonusUi/Timeline/TimelineContainer";

const TimeLine = () => {
  return <TimelineContainer />;
};

export default TimeLine;
